<template>
  <MainCenter>
    <Article :article="{ type: 11 }"></Article>
  </MainCenter>
</template>

<script>
import MainCenter from '@/components/layout/MainCenter.vue'
import Article from '@/components/article/Article.vue'
export default {
  name: 'NejmCatalog',
  components: { Article, MainCenter },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped></style>
